module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHER")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGARDING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGITAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WELVE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHETS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1dev1"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2"
    }
  }, [_vm._v("God Tells Hosea to Marry a Harlot Hosea 1:1-3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap3"
    }
  }, [_vm._v("Prophetic Significance of Hosea’s Family Hosea 1:4-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap4"
    }
  }, [_vm._v("Israel’s Sin and Restoration Hosea 2:1-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap5"
    }
  }, [_vm._v("Divine Mercy on Israel Hosea 2:19-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap6"
    }
  }, [_vm._v("The Restoration of Gomer Hosea 3:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap7"
    }
  }, [_vm._v("Divine Accusations Against Israel Hosea 4:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap8"
    }
  }, [_vm._v("Divine Punishment for Idolatry Hosea 4:9-19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap9"
    }
  }, [_vm._v("Impending Judgment on Israel and Judah Hosea 5:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap10"
    }
  }, [_vm._v("Call for Repentance Hosea 6:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free Refusal to Repent Hosea 6:11—7:16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sow the Wind, Reap the Whirlwind Hosea 8:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Days of Punishment Hosea 9:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judgment of Captivity Hosea 10:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fruit of Righteousness and the Fruit of Iniquity Hosea 10:12-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unconditional Fatherly Love Hosea 11:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Pedagogical Care for the Rebel Hosea 12:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shall I Redeem Them from Death? Hosea 13:1-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ways of the Lord are Right Hosea 14:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invasion of Locusts Joel 1:1-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Day of the Lord Joel 2:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repentance and Forgiveness Joel 2:12-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redemption of the Lord Joel 2:18-27")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eschatological Outpouring of the Spirit Joel 2:28-32")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Judgment of the Lord Joel 3:1-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MOS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judgment on Israel’s Neighbors Amos 1:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judgment on Israel Amos 2:1-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charges Against Israel Amos 3:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine Sentence Amos 4:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lament and Call for Repentance Amos 5:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Execution of the Divine Verdict: The Day of the Lord Amos 5:18-27")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Condemnation of Complacency and Luxurious Living Amos 6:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prophet and His Prophecy Amos 7:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Time is Ripe for Divine Punishment Amos 8:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destruction and Restoration of Israel Amos 9:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p4dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BADIAH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vision of Obadiah Obadiah 1-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p5dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONAH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah’s Reluctance Jonah 1:1-3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah’s Failed Escape Jonah 1:4-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah’s Prayer from the Heart of the Sea Jonah 2:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah’s Preaching of Repentance Jonah 3:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ninevites Repent Jonah 3:5-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p5chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ambivalence of Jonah Jonah 4:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p6dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICAH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecy of Weeping and Mourning Micah 1:1-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refuge and Deliverance Micah 2:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rebuke of Prophets and Leaders of Israel Micah 3:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mountain of the Lord Micah 4:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Messiah from Bethlehem Micah 5:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lord’s Trial Over Israel Micah 6:1-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sin and Misery of Israel Micah 7:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p6chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salvation of Israel Micah 7:14-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p7dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHUM")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p7chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Punishment of Nineveh Nahum 1:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p7chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woe to the City of Blood Nahum 2:1—3:19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p8dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABAKKUK")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p8chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Long, O Lord? Habakkuk 1:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p8chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Revelation Awaits an Appointed Time Habakkuk 2:1-3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p8chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Live By Faith Habakkuk 2:4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p8chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woes to the Wicked Habakkuk 2:5-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p8chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Repentance and Doxology Habakkuk 3:1-2")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p8chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine Advent Habakkuk 3:3-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p8chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joy in the God of Salvation Habakkuk 3:7-19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p9dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPHANIAH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p9chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Judgment of the Day of the Lord Zephaniah 1:1-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p9chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Punishment of the Proud Zephaniah 2:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p9chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Punishment Followed by Mercy Zephaniah 3:1-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p10dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGGAI")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p10chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rebuild the House of the Lord Haggai 1:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p10chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heaven and Earth Will Shake Haggai 1:15—2:7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p10chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Blessing for the Restoration of the Temple Zephaniah 2:8-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p11dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECHARIAH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lord’s Call to Repentance Zechariah 1:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Visions Concerning Jerusalem Zechariah 1:7-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Symbolic Measuring of Jerusalem Zechariah 2:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lord’s Rebuke of Satan Zechariah 3:1-2")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Symbolic Cleansing of Joshua Zechariah 3:3-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Visions of the Golden Lampstand and Two Olive Trees Zechariah 4:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Visions of the Flying Scroll and the Woman in the Ephah Zechariah 5:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visions of Four Chariots and the Crowning of Joshua Zechariah 6:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proper Fasting and Repentance Zechariah 7:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Future of Israel: Love Truth, Justice and Peace Zechariah 8:1-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecy About the Coming of the Messianic King of Jerusalem Zechariah 9:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eschatological Kingdom of the Lord Zechariah 9:10-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warning to the Shepherds of Israel Zechariah 10:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woe to the Worthless Shepherds Zechariah 11:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oppression and Salvation of Judah Zechariah 12:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Day of Mourning in Jerusalem Zechariah 12:10-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Renewal of the Testament with the Remnant of Israel Zechariah 13:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p11chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eschatological Kingdom of the Lord Zechariah 14:1-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p12dev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALACHI")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rebuke of Israel’s Priesthood and Sacrifice Malachi 1:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proper and Improper Sacrifices Malachi 1:10-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guilt and Condemnation of the Priests Malachi 2:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine Condemnation of Idolatry and Divorces Malachi 2:10-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecy About the Herald of the Lord Malachi 3:1")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coming Judgment of the Lord Malachi 3:2-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judgment of the Righteous and the Wicked Malachi 3:10-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rise of the Sun of Righteousness Malachi 4:1-3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p12chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elijah’s Coming Before the Day of the Lord Malachi 4:4-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(": E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCUMENTS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITED")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOGRAPHICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KETCHES")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESCRIPTIONS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELECT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NONYMOUS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMELINE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRISTIC")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIOD")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANGUAGES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORS")]), _vm._v("/W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITINGS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBJECT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPYRIGHT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0